// extracted by mini-css-extract-plugin
module.exports = {"container":"ForgotPasswordModal_container__htqEC","logoContainer":"ForgotPasswordModal_logoContainer__2yo2_","disclaimer":"ForgotPasswordModal_disclaimer__2-y_o"};